import { render, staticRenderFns } from "./xgToolTip.vue?vue&type=template&id=bca4f108"
import script from "./xgToolTip.vue?vue&type=script&lang=js"
export * from "./xgToolTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca4f108')) {
      api.createRecord('bca4f108', component.options)
    } else {
      api.reload('bca4f108', component.options)
    }
    module.hot.accept("./xgToolTip.vue?vue&type=template&id=bca4f108", function () {
      api.rerender('bca4f108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/pddPrint/components/xgToolTip.vue"
export default component.exports